import React from 'react';
import Text from 'component/typography/Text';

import {colors, sizes} from 'asset/constant';
export default function InputLabel({label = '', desc = ''}) {
  return (
    <Text
      color={colors.text.gray}
      style={{marginRight: sizes.space / 2, marginBottom: sizes.space / 2}}
      weight="medium">
      {label}
      {desc && (
        <Text color={colors.text.muted} size={'xs'}>
          {' '}
          {desc}
        </Text>
      )}
    </Text>
  );
}
